const getLatLngLiteralForPlace = async (placesLib: (google.maps.PlacesLibrary | null), placeId: string) => {

    if (!placesLib || placeId.length === 0) {
        console.warn("Invalid placesLib or empty placeId.");
        return null;
    }

    // Use place ID to create a new Place instance.
    const selectedPlace = new placesLib.Place({
        id: placeId,
    });

    // Call fetchFields, passing the desired data fields.
    await selectedPlace.fetchFields({
        fields: ["location"],
    });

    // Check if location is available and return the coordinates.
    if (selectedPlace.location) {
        return {
            lat: selectedPlace.location.lat(),
            lng: selectedPlace.location.lng(),
        };
    } else {
        console.warn("Location data not available for the given placeId.");
        return null;
    }

}

export default getLatLngLiteralForPlace